import React, { useEffect } from "react";
import { RouteProps } from "react-router-dom";
import styled from "styled-components";
import { PageTemplateINeedHelpAcf } from "../../constants/types/acf";
import { useThemeColors } from "../../controllers";
import { useCurrentRouteData } from "../../services/app-state";
import { colors } from "../../utils/colors";
import { HeroNeedHelpNow } from "../organisms/HeroNeedHelpNow";
import { OtherSupport } from "../organisms/HomeOtherSupport";
import { NeedHelpNowCards } from "../organisms/NeedHelpNowCards";
import { NotSureWhereToBegin } from "../organisms/NotSureWhereToBegin";

const PageWrapper = styled.div``;

export const NeedHelpNowTemplate: React.FC<RouteProps> = () => {
    const page = useCurrentRouteData<PageTemplateINeedHelpAcf>();
    const { setThemeColor } = useThemeColors();

    const { hero, content } = page.acf;

    useEffect(() => {
        setThemeColor(c => c.needHelpNow);
        return () => {
            setThemeColor(c => c.default);
        };
    }, [setThemeColor]);

    return (
        <>
            <HeroNeedHelpNow
                title={hero.title}
                subtitle={hero.subtitle}
                buttonText={hero.button_text}
            />
            <PageWrapper>
                <NeedHelpNowCards
                    title={content.title}
                    copy={content.copy}
                    cards={content.cards || []}
                />

                <OtherSupport />
                <NotSureWhereToBegin topColor={colors.brandMid} bottomColor={"white"} />

            </PageWrapper>
        </>
    );
};
